import { Send } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

export function SendMessageInput() {
  const [message, setMessage] = useState("");
  const addMessage = useVidyoStore((s) => s.chat.addMessage);
  const vidyoConnector = useVidyoStore((s) => s.vidyoSDK);
  const handleSendMessage = async () => {
    if (!message.trim() || !vidyoConnector) return;

    /**
     * we need to add our own message to the chat,
     * because the onChatMessageReceived in createChatLifecycle only fires
     * for messages sent by the other participant
     */
    addMessage({
      message,
      participantName: "You",
      timestamp: new Date(),
      participantId: "You",
    });
    setMessage("");

    /**
     * send the message to the other participant
     */
    await vidyoConnector.SendChatMessage({ message });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  return (
    <div className="relative flex">
      <Input
        type="text"
        placeholder="Type a message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        className="pr-8"
      />

      <Button
        variant="ghost"
        size="icon"
        type="button"
        className="absolute right-0 top-1/2 -translate-y-1/2 hover:bg-transparent"
        onClick={handleSendMessage}
      >
        <Send className="size-4" aria-label="Send message" />
      </Button>
    </div>
  );
}
